import React, { useState, useEffect, useMemo } from 'react';
import { TextField, Button, FormControl, InputAdornment } from '@mui/material';

import toast from 'react-hot-toast';
import './CisModal.scss';

import { submitCisData, submitAR, submitEventCisData, submitEventAR } from '../../helper/helper';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import { addonList, PPPaddons, AppleCareAddons, channelCode } from '../utils';
import CustomButton from '../../components/ui/Button/Button';
import SelectField from './FormSelect';
// import { DFF_Text } from './fileTempates';
import { getTodayDate } from '../../components/ReusableFunctions';
import { readSkus } from './pdfUtils';

const fieldsToIgnoreForNA = ["storeInvoice","saleInvoice","tenderedDate","time",'storeId', 'specialistId', 'connectionType',"email","user","customerName","activationDate"];
const NA_Text = "N/A"


// const dummyData = {
//   storeInvoice: 'LAKESIN',
//   saleInvoice: 'LAKESIN41341',
//   tenderedDate: '2025-04-05',
//   time: '05:48 PM',
//   customerName: 'Shelby Laidlaw',
//   email: 'shelbylaidlaw@icloud.com',
//   accountNum: 'DBC50025189064',
//   deposit: 'Not Required',
//   retailPrice: 'N/A',
//   phoneProtectionPlan: '',
//   activatedPromotion: '$4/Month Credit(Monthly ongoing credit with select plans; starts 1st b…',
//   phoneNum: '647-473-6596',
//   tempPhoneNum: '647-575-0694',
//   simNumber: '8914900010148335114',
//   imei: 'N/A',
//   amountYouPaid: 'N/A',
//   connectionType: 'Postpaid',
//   activationDate: '2025-04-05',
//   phoneMake: 'Bring Your Own Phone',
//   planName: 'Can-U.S.-Mex 60GB + 5G+ and Roam Beyond 5GB Data Pass',
//   planPrice: '$44',
//   myBalanceOwing: 'ble',
//   oneTimeCharges: '$45.00',
//   addons: '',
//   autoPayPre: 'N/A',
//   autoPayPost: 'N/A',
//   storeId: '',
//   specialistId: '',
//   user: '',
// };

const initialFormState = {
  storeInvoice: '',
  saleInvoice: '',
  tenderedDate: '',
  time: '',
  customerName: '',
  email: '',
  accountNum: '',
  deposit: '',
  retailPrice: '',
  phoneProtectionPlan: '',
  activatedPromotion: '',
  phoneNum: '',
  tempPhoneNum: '',
  simNumber: '',
  imei: '',
  amountYouPaid: '',
  // Default Value
  connectionType: 'Postpaid',
  // Default Value Current Date
  activationDate: getTodayDate(),
  phoneMake: '',
  planName: '',
  planPrice: '',
  myBalanceOwing: '',
  oneTimeCharges: '',
  addons: '',
  autoPayPre: '',
  autoPayPost: '',
  specialistId: '',
  storeId: '',
};

const CisModal = ({ modalIsOpen, closeModal, rqCISFormresult, eventinfoforCis = null, manualSkuList }) => {
  const username = localStorage.getItem('username');
  const userDetails = useMemo(() => JSON.parse(localStorage.getItem('user_data')), []);
  const [isChecked, setIsChecked] = useState(false);
  const [formData, setFormData] = useState(
    eventinfoforCis
      ? {
          ...initialFormState,
          eventName: eventinfoforCis?.name || '',
          eventDate: eventinfoforCis?.date || '',
          user: username,
          sign: true,
        }
      : { ...initialFormState, user: username, sign: true },
  );

  const [errors, setErrors] = useState({});

  const fieldsConfigurations = {
    saleInvoice: { title: 'Sale Invoice', type: 'string', readOnly: true },
    storeInvoice: { title: 'Store Invoice', type: 'string', readOnly: true },
    tenderedDate: { title: 'Tendered Date', type: 'date', readOnly: true },
    time: { title: 'Time', type: 'string', readOnly: true },
    customerName: { title: 'Customer Name', type: 'string' },
    email: { title: 'Email Address', type: 'email' },
    accountNum: { title: 'Account Number', type: 'string' },
    deposit: { title: 'Deposit Amount', type: 'string', prefix: '$' },
    retailPrice: { title: 'Retail Price', type: 'string', prefix: '$' },
    phoneProtectionPlan: { title: 'Phone Protection Plan', type: 'string' },
    activatedPromotion: { title: 'Activated Promotion', type: 'string' },
    phoneNum: { title: 'Phone Number', type: 'string',validation: /^\d{10}$/  },
    tempPhoneNum: { title: 'Temporary Phone Number', type: 'string',validation: /^\d{10}$/  },
    simNumber: { title: 'SIM Number', type: 'string' },
    imei: { title: 'IMEI', type: 'string'  },
    amountYouPaid: { title: 'Amount Paid', type: 'string', prefix: '$' },
    connectionType: { title: 'Connection Type', type: 'string' },
    activationDate: { title: 'Activation Date', type: 'date' },
    phoneMake: { title: 'Phone Make', type: 'string' },
    planName: { title: 'Plan Name', type: 'string' },
    planPrice: { title: 'Plan Price', type: 'string', prefix: '$' },
    myBalanceOwing: { title: 'Balance Owing', type: 'string', prefix: '$' },
    oneTimeCharges: { title: 'One-Time Charges', type: 'string', prefix: '$' },
    addons: { title: 'Add-Ons', type: 'string' },
    autoPayPre: { title: 'Auto Pay Prepaid', type: 'string' },
    autoPayPost: { title: 'Auto Pay Postpaid', type: 'string' },
    specialistId: { title: 'Specialist ID', type: 'string' },
    storeId: { title: 'Store ID', type: 'string' },
    user: { title: 'User', type: 'string', readOnly: true },
    eventName: { title: 'Event Name', type: 'string' },
    eventDate: { title: 'Event Date', type: 'date' },
  };

  useEffect(() => {
    if (rqCISFormresult) {
      let { simNumber, salesPerson,accountNum,imei,storeInvoice, ...values } = rqCISFormresult;
      let storeId = channelCode[storeInvoice] || ''
      if (values) {
        setFormData((prevData) => ({ ...prevData, phoneNum: simNumber,accountNum:accountNum,imei :imei, storeId,storeInvoice,  ...values }));
      }
    }
  }, [rqCISFormresult]);

  const validateField = (name, value) => {
    let error = '';

    const validationRule = fieldsConfigurations[name]?.validation;
    if (validationRule && !validationRule.test(value)) {
        error = `${fieldsConfigurations[name].title} must be exactly 10 digits.`;
    }

    return error;
  };

  const handleSetNA = () => {
    setFormData((prevData) => {
      const updatedData = {};
      Object.keys(prevData).forEach((key) => {
        if (!fieldsToIgnoreForNA.includes(key)) {
          updatedData[key] = prevData[key] === '' ? NA_Text : prevData[key];
        } else {
          updatedData[key] = prevData[key];
        }
      });
      return updatedData;
    });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (fieldsConfigurations[name]?.type === 'date' && value === '') {
        return;
    }
    const error = validateField(name, value);
    setErrors((prevErrors) => ({ ...prevErrors, [name]: error }));
    setFormData((prevData) => {
      const updatedData = { ...prevData, [name]: value };

      // Automatically update storeInvoice based on saleInvoice
      if (name === 'saleInvoice') {
        const nonNumericPart = value.replace(/\d+/g, ''); // Extract non-numeric part
        updatedData.storeInvoice = nonNumericPart; // Update storeInvoice fiel
      }

      if (name === 'autoPayPre') {
        if (value !== NA_Text) {
          updatedData.autoPayPost = NA_Text; // Set autoPayPost to "N/A" if autoPayPre is not "N/A"
        }
      } else if (name === 'autoPayPost') {
        if (value !== NA_Text) {
          updatedData.autoPayPre = NA_Text; // Set autoPayPre to "N/A" if autoPayPost is not "N/A"
        }
      }
      /* if (name === "activationDate") {
                updatedData.activationDate = dateConversion(value)
            } */

      return updatedData;
    });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const newErrors = {};
    // Check for empty fields

    Object.keys(formData).forEach((field) => {
      if (!formData[field]) {
        newErrors[field] = `${fieldsConfigurations[field].title} is required`;
      }
    });
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
    toast.error('Please fill all required fields.');
    } else {
      setErrors({});
      // Commenting CHeck because now user can not get to this poit if valid RQ is not provided 

        const { accessories: attachedAcc, discountInfo = {}, newAccessoriesList } = readSkus(manualSkuList, rqCISFormresult);

        let totalCost = 0;
        let totalMsrp = 0;
        let totalDiscount = 0;
        attachedAcc.forEach((item) => {
          const [sku /* productName */, , cost, msrp] = item;
          totalCost += cost;
          totalMsrp += msrp;
          if (discountInfo[sku] && discountInfo[sku].discount) {
            totalDiscount += discountInfo[sku].discount;
          }
        });
        let aaData = {
          cost: totalCost,
          msrp: totalMsrp,
          discount: totalDiscount,
        };

        const formattedData = { ...formData };

        Object.keys(fieldsConfigurations).forEach((field) => {
          if (fieldsConfigurations[field].prefix && formData[field] && formData[field] !== NA_Text) {
            formattedData[field] = `${fieldsConfigurations[field].prefix}${formData[field]}`;
          }
        });

        const {
          storeInvoice,
          saleInvoice,
          tenderedDate,
          time,
          customerName,
          email,
          accountNum,
          deposit,
          retailPrice,
          phoneProtectionPlan,
          activatedPromotion,
          phoneNum,
          tempPhoneNum,
          simNumber,
          imei,
          amountYouPaid,
          connectionType,
          activationDate,
          phoneMake,
          planName,
          planPrice,
          myBalanceOwing,
          oneTimeCharges,
          addons,
          autoPayPre,
          autoPayPost,
          specialistId,
          storeId,
          user,
          eventName,
          eventDate,
        } = formattedData;

        if (isChecked) {
          const payload = {
            storeInvoice,
            saleInvoice,
            tenderedDate,
            time,
            customerName,
            email,
            accountNum,
            deposit,
            retailPrice,
            phoneProtectionPlan,
            activatedPromotion,
            phoneNum,
            tempPhoneNum,
            simNumber,
            imei,
            amountYouPaid,
            connectionType,
            activationDate,
            phoneMake,
            planName,
            planPrice,
            myBalanceOwing,
            oneTimeCharges,
            addons,
            autoPayPre,
            autoPayPost,
            specialistId,
            storeId,
            user,
            manuallyUploadedBy: userDetails?._id,
          };

          const homePromise = eventinfoforCis
            ? submitEventCisData({ ...payload, eventName, eventDate })
            : submitCisData(payload);

          homePromise
            .then(() => {
              if (eventinfoforCis) {
                submitEventAR({
                  specialistId,
                  tenderedDate,
                  saleInvoice,
                  discountInfo,
                  attachedAcc,
                  connectionType,
                  simNumber,
                  user,
                  aaData,
                  storeInvoice,
                  phoneProtectionPlan,
                  imei,
                  eventName,
                  eventDate,
                    newAccessoriesList,
                }).catch(() => {});
              } else {
                submitAR({
                  specialistId,
                  tenderedDate,
                  saleInvoice,
                  discountInfo,
                  attachedAcc,
                  connectionType,
                  simNumber,
                  user,
                  aaData,
                  storeInvoice,
                  phoneProtectionPlan,
                  imei,
                    newAccessoriesList,
                }).catch(() => {});
              }
            })
            .catch(() => {});
        }
      closeModal();
    }
  };

  const handleFieldFocus = (e) => {
    const { name, value } = e.target;
    if (value === 'N/A' && fieldsConfigurations[name]?.prefix) {
      setFormData((prevData) => ({
        ...prevData,
        [name]: '',
      }));
    }
  };

  return modalIsOpen && (
    <div className="cisForm-Modal">
      <div className="modal-container">
        <h2>CIS Form</h2>
        <form onSubmit={handleSubmit}>
          {Object.keys(formData).map((field) => (
            <div className="form-field" key={field}>
              {field === 'connectionType' ? (
                <SelectField
                  field={field}
                  fieldTitles={fieldsConfigurations}
                  formData={formData}
                  handleInputChange={handleInputChange}
                  options={['Postpaid', 'Prepaid']}
                />
              ) : field === 'phoneProtectionPlan' ? (
                <SelectField
                  field={field}
                  fieldTitles={fieldsConfigurations}
                  formData={formData}
                  handleInputChange={handleInputChange}
                  options={['N/A', ...PPPaddons, ...AppleCareAddons]}
                />
              ) : field === 'autoPayPre' || field === 'autoPayPost' ? (
                <SelectField
                  field={field}
                  fieldTitles={fieldsConfigurations}
                  formData={formData}
                  handleInputChange={handleInputChange}
                  options={['N/A', 'successfully for Pre - Authorized Payments']}
                />
              ) : field === 'addons' ? (
                <SelectField
                  field={field}
                  fieldTitles={fieldsConfigurations}
                  formData={formData}
                  handleInputChange={handleInputChange}
                  options={['N/A', ...addonList]}
                />
              ) : field === 'sign' ? (
                <FormControl fullWidth>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={isChecked}
                        onChange={(e) => setIsChecked(e.target.checked)}
                        color="primary"
                        name="checkbox"
                        id="name"
                        inputProps={{
                          autoComplete: 'true',
                        }}
                      />
                    }
                    label="By selecting, you confirm the CIS is signed by both you and the Customer."
                  />
                </FormControl>
              ) : (
                <TextField
                  name={field}
                  label={`${fieldsConfigurations[field].title} *`}
                  type={`${fieldsConfigurations[field].type ? fieldsConfigurations[field].type : ''}`}
                  value={formData[field]}
                  onChange={handleInputChange}
                  onFocus={handleFieldFocus}
                  fullWidth
                  error={!!errors[field]}
                  autoComplete="off"
                  InputProps={{
                    readOnly: fieldsConfigurations[field]?.readOnly || false,
                    style: { textTransform: 'uppercase' },
                    startAdornment: fieldsConfigurations[field]?.prefix ? (
                      <InputAdornment position="start">
                        {formData[field] !== 'N/A' ? fieldsConfigurations[field].prefix : ''}
                      </InputAdornment>
                    ) : null,
                  }}
                  helperText={
                    errors[field]
                      ? errors[field]
                      : !fieldsToIgnoreForNA.includes(field) && 'Add "N/A" if no data is available.'
                  }
                />
              )}
            </div>
          ))}
          <div className="form-actions">
            <CustomButton type="submit" disabled={!isChecked} btnLabel="Submit" />
            <Button className="cancel-btn" onClick={handleSetNA}>
              Set Empty Fields to N/A
            </Button>
            <Button className="cancel-btn" onClick={closeModal}>
              Cancel
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CisModal;
